import { React, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Flex,
  Text,
  Tooltip,
  IconButton,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import { FiX } from 'react-icons/fi';
import { STORAGE_KEYS, ROUTES } from '../constants.js';
import { useGeneralContext } from './GeneralContext.js';
import theme from '../theme.js';

const NavItem = ({ icon: Icon, name, to, isCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { deleteCharacter } = useGeneralContext();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();

  return (
    <Tooltip label={isCollapsed ? name : ''} placement="right" openDelay={300}>
      <Flex
        as="a"
        href={to}
        align="center"
        justify={isCollapsed ? 'center' : 'space-between'}
        p={0.75}
        borderRadius="md"
        role="group"
        transition="background 0.2s"
      >
        <Flex align="center" gap={3}>
          <Box as={Icon} boxSize={5} />
          {!isCollapsed && (
            <Text fontWeight="medium" flex="1">
              {name}
            </Text>
          )}
        </Flex>

        {!isCollapsed && (
          <IconButton
            aria-label={`Delete ${name}`}
            icon={<FiX />}
            size="xl"
            opacity={0}
            _groupHover={{ opacity: 1 }}
            onClick={e => {
              e.preventDefault();
              onOpen();
            }}
          />
        )}
      </Flex>

      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete {name}
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to delete the character <b>{name}</b>? This
              action cannot be undone.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                backgroundColor={theme.colors.red}
                color={theme.colors.neutralLight}
                _hover={{ backgroundColor: theme.colors.redDark }}
                onClick={() => {
                  deleteCharacter(name);
                  if (
                    location.pathname.includes(
                      STORAGE_KEYS.CHARACTER_PREFIX + name
                    )
                  )
                    navigate(ROUTES.CHARACTER);
                  onClose();
                }}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Tooltip>
  );
};

export default NavItem;
